import BookingTimesResult from "@/pages/Report/BookingTimesResult";
import BookingMethodResult from "@/pages/Report/BookingMethodResult";
import BookingCourtsResult from "@/pages/Report/BookingCourtResult";
import BookingVenueResult from "@/pages/Report/BookingVenueResult";

const incomeBookingType = {
  INCOME: 'INCOME',
  REFUND: 'REFUND'
}
const incomeBookingStyle = {
  INCOME: 'text-green-success bg-green-subtle',
  REFUND: 'text-red-secondary bg-red-subtle'
}
const incomeBookingPriceStyle = {
  INCOME: 'text-green-success',
  REFUND: 'text-red-secondary'
}

const bookingInsightType = {
  BOOKING_TIMES: 'BOOKING_TIMES',
  BOOKING_METHOD: 'BOOKING_METHOD',
  APP_PAYMENT_METHOD: 'APP_PAYMENT_METHOD',
  COURTS: 'COURTS',
  VENUE: 'VENUE'
}
const bookingInsightTypes = [
  bookingInsightType.BOOKING_TIMES,
  bookingInsightType.BOOKING_METHOD,
  bookingInsightType.COURTS,
  bookingInsightType.VENUE
]

const bookingResults = {
  BOOKING_TIMES: BookingTimesResult,
  BOOKING_METHOD: BookingMethodResult,
  COURTS: BookingCourtsResult,
  VENUE: BookingVenueResult
}

const pieColors = [
  '#A155B9',
  '#17BFD6',
  '#165BA9',
  '#F764A2',
  '#33e4c8'
]

export {
  pieColors,
  incomeBookingType,
  incomeBookingStyle,
  incomeBookingPriceStyle,
  bookingInsightType,
  bookingInsightTypes,
  bookingResults
}